import {Base} from "@/api/Base"

export class MpfList extends Base {
    path = "mpf/list"
}